import {
	css3,
	express,
	git,
	github,
	vscode,
	postman,
	html5,
	javascript,
	mongodb,
	mysql,
	node,
	react,
	photoshop,
	illustrator,
	figma,
	autocad,
	_3dmax,
	solidworks,
	sketchUp,
	vray,
} from "../../public/images";

const personalInfo = {
	phoneNumber: "(+63) 09553589102",
	email: "vjunfel@gmail.com",
	location: "Cebu, Philippines",
};

const techstack = [
	{
		frontend: [
			{ name: "HTML5", value: 95, img: html5, alt: "html5" },
			{ name: "CSS3", value: 90, img: css3, alt: "css3" },
			{ name: "JavaScript", value: 80, img: javascript, alt: "JavaScript" },
			{ name: "React", value: 75, img: react, alt: "react" },
		],
		backend: [
			{ name: "Node.js", value: 60, img: node, alt: "node" },
			{ name: "Express", value: 60, img: express, alt: "express" },
			{ name: "MongoDB", value: 70, img: mongodb, alt: "mongodb" },
			{ name: "MySQL", value: 50, img: mysql, alt: "mysql" },
		],
		tools: [
			{ name: "Git", img: git, alt: "git" },
			{ name: "Github", img: github, alt: "Github" },
			{ name: "VSCode", img: vscode, alt: "VSCode" },
			{ name: "Postman", img: postman, alt: "Postman" },
		],
	},
];

export const SkillsData = [
	{
		category: "Web Developement Technology",
		technology: [
			{ name: "HTML", value: 95, img: html5, alt: "html5" },
			{ name: "CSS", value: 90, img: css3, alt: "css3" },
			{ name: "Javascript", value: 80, img: javascript, alt: "javascript" },
			{ name: "React JS", value: 75, img: react, alt: "react" },
			{ name: "Express JS", value: 60, img: express, alt: "express" },
			{ name: "Node JS", value: 60, img: node, alt: "node" },
			{ name: "MongoDB", value: 70, img: mongodb, alt: "mongodb" },
			{ name: "MySQL", value: 50, img: mysql, alt: "mysql" },
			{ name: "Git", value: 80, img: git, alt: "git" },
		],
	},
	{
		category: "Design Tools",
		design: [
			{
				name: "Adobe Photoshop",
				value: 95,
				img: photoshop,
				alt: "Photoshop",
			},
			{
				name: "Adobe Illustrator",
				value: 40,
				img: illustrator,
				alt: "Illustrator",
			},
			{ name: "Figma", value: 85, img: figma, alt: "Figma" },
		],
	},
	{
		category: "CAD / 3D Tools",
		_3d: [
			{ name: "Autocad", value: 95, img: autocad, alt: "Autocad" },
			{ name: "3ds Max", value: 95, img: _3dmax, alt: "3ds Max" },
			{
				name: "Solidworks Mechanical",
				value: 90,
				img: solidworks,
				alt: "Solidworks",
			},
			// { name: "Sketch Up", value: 60, img: sketchUp, alt: "Sketch Up" },
			{ name: "Vray", value: 90, img: vray, alt: "Vray" },
		],
	},
];

const ExperiencedData = [
	{
		position: "Web Developer",
		company: "Freelance",
		location: "Philippines",
		dateRange: "Jan 2023 - Present",
		responsibilities: ["Help businesses develop their website."],
	},
	{
		position: "UI / UX Designer",
		company: "Cpeso Inc.",
		location: "Mandaue City",
		dateRange: "Jun 2023 - Oct 2024",
		responsibilities: [
			"Design mobile and web applications using Figma.",
			"Create UI mockups and prototypes that clearly illustrate how sites/apps function and look like.",
			"Develop the company's website using ReactJS.",
		],
	},
	{
		position: "3d Artist - Freelance",
		company: "Nfinite",
		location: "France",
		dateRange: "Aug 2022 - Dec 2022",
		responsibilities: [
			"Create 3d models using Autodesk 3ds Max software.",
			"Texture the models using Vray-5.",
			"Conduct validation to ensure the products comply with all client's requirements and specifications.",
		],
	},
	{
		position: "Senior 3d Artist",
		company: "Ripeconcepts Inc.",
		location: "Cebu City",
		dateRange: "Apr 2019 - Aug 2022",
		responsibilities: [
			"Create 3d models based on client specifications and requirements using various 3d tools.",
			"Unwrap and texture 3d models as realistic as possible with respect to PRI using Vray 5.",
			"Validate and troubleshoot any errors encountered during the process.",
		],
	},
	{
		position: "Industrial Designer",
		company: "Al-Hasaniah",
		location: "Saudi Arabia",
		dateRange: "Jun 2016 - Jul 2018",
		responsibilities: [
			"Create customized marble designs.",
			"Provide material computations and process plans.",
			"Communicate with clients, factory manager, and co-designer for smooth transactions.",
			"Machine troubleshooting and maintenance for CNC, Water Jet, Polisher, and Stone-Cut.",
			"Create Program using JDPaint software and provide G-Code for CNC machines.",
		],
	},
	{
		position: "CAD Engineering Technician",
		company: "Fairchild Semiconductor",
		location: "Lapu-lapu City",
		dateRange: "Feb 2011 - Jul 2015",
		responsibilities: [
			"Create detailed drawing for Leadframes, Clipframes, Marketing drawings, and Mold drawings using Autocad.",
			"Create/design Conversion Kit for different Wirebond machines, Jigs and fi xtures using Solidworks.",
		],
	},
	{
		position: "Graphic Designer",
		company: "Art Graphics",
		location: "Mati City",
		dateRange: "Oct 2009 - Oct 2010",
		responsibilities: [
			"Create tarpaulin design, invitation card, greetings card, sticker design, T-shirt printing design, and logo design.",
			"Photo editing and enhancement.",
		],
	},
];

const TrainingData = [
	{
		name: "Modern JavaScript From The Beginning 2.0",
		provider: "Traversy Media",
		certificateNumber: "fb090df6",
		link: "https://app.kajabi.com/certificates/fb090df6",
	},
	{
		name: "Solidworks Mechanical Design (Professional)",
		provider: "Dassault Systemes",
		certificateNumber: "C-EVS8YU7QMC",
		link: "https://3dexperience.virtualtester.com/userportal.php/userportal?locale=en#certvalidate",
	},
	{
		name: "Solidworks Mechanical Design (Associate)",
		provider: "Dassault Systemes",
		certificateNumber: "C-K64ZUC9F5G",
		link: "https://3dexperience.virtualtester.com/userportal.php/userportal?locale=en#certvalidate",
	},
	{
		name: "Solidworks Essentials",
		provider: "GoEngineer",
		certificateNumber: "cert_nhckvyw2",
	},
	// {
	// 	name: "Solidworks Advanced Part Modeling",
	// 	provider: "GoEngineer",
	// 	certificateNumber: "cert_g9zy9h92",
	// },
	// {
	// 	name: "Solidworks Advanced Drawing",
	// 	provider: "GoEngineer",
	// 	certificateNumber: "cert_xz4rj96q",
	// },
	// {
	// 	name: "Solidworks Advanced Modeling",
	// 	provider: "GoEngineer",
	// 	certificateNumber: "cert_1pvgwcrn",
	// },
];

export { personalInfo, techstack, ExperiencedData, TrainingData };
